// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../Config.bs.js";
import * as Sentry from "../library/sentry/Sentry.bs.js";
import * as Datadog from "../library/datadog/Datadog.bs.js";
import * as Caml_option from "../../node_modules/rescript/lib/es6/caml_option.js";
import * as InitializeGA from "../library/event-tracker/react-ga/initializer/InitializeGA.bs.js";
import * as CrmRouteManager from "./crm/to-be-migrated/routing/CrmRouteManager.bs.js";
import * as HeaderComponent from "../library/components/HeaderComponent.bs.js";
import * as CountryConfigCmp from "../library/data-source/country-config/component/CountryConfigCmp.bs.js";
import * as CrmErrorBoundary from "../library/components/generic-components/components/CrmErrorBoundary.bs.js";
import * as RescriptReactRouter from "../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as WebsiteRouteManager from "./website/routing/WebsiteRouteManager.bs.js";
import * as OrderMapRouteManager from "./crm/to-be-migrated/routing/order-map/OrderMapRouteManager.bs.js";
import * as SomethingWentWrongCmp from "../library/components/generic-components/components/SomethingWentWrongCmp.bs.js";
import * as CircularLoader$Catalyst from "../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as LazyOrderMapWrapperComponent from "./crm/order-dashboard/view/components/order-map/components/LazyOrderMapWrapperComponent.bs.js";
import * as LazyWorkSpaceComponentWrapper from "../library/work-space/LazyWorkSpaceComponentWrapper.bs.js";

function findSomeWithDefault(l, $$default) {
  var opt_r = List.fold_left((function (acc, func) {
          if (acc !== undefined) {
            return acc;
          } else {
            return Curry._1(func, undefined);
          }
        }), undefined, l);
  if (opt_r !== undefined) {
    return Caml_option.valFromOption(opt_r);
  } else {
    return $$default;
  }
}

function getInitialRoute(initialUrl) {
  var tab = CrmRouteManager.getCrmTab(initialUrl);
  if (tab !== undefined) {
    return {
            TAG: /* WorkSpace */0,
            _0: tab
          };
  } else {
    return findSomeWithDefault({
                hd: (function (param) {
                    return WebsiteRouteManager.RouteManager.getTrackOrder(initialUrl);
                  }),
                tl: {
                  hd: (function (param) {
                      return OrderMapRouteManager.RouteManager.renderOrderMap(initialUrl);
                    }),
                  tl: /* [] */0
                }
              }, /* DefaultDashboard */0);
  }
}

function App$App(Props) {
  Curry._2(Sentry.setTag, "INFRA_STACK", process.env.INFRA_STACK);
  React.useEffect((function () {
          Datadog.initDatadogCfg(Config.Env.env, Config.Env.dd_app_id, process.env.DD_CLIENT_TOKEN, 0, 0);
          Datadog.startRecording(undefined);
          return (function (param) {
                    return Datadog.stopRecording(undefined);
                  });
        }), []);
  var route = getInitialRoute(RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined));
  var match = Config.Env.env;
  var tmp;
  var exit = 0;
  switch (match) {
    case "production" :
    case "staging" :
        exit = 1;
        break;
    default:
      tmp = "None";
  }
  if (exit === 1) {
    var match$1 = process.env.INFRA_STACK;
    tmp = match$1 === "uae" ? Config.Env.ga_tracking_id_uae : Config.Env.ga_tracking_id;
  }
  InitializeGA.useGaInitializer(true, tmp);
  return React.createElement(CountryConfigCmp.make, {
              children: (function (param) {
                  if (typeof route === "number") {
                    return React.createElement("div", undefined, "HomePage");
                  } else if (route.TAG === /* WorkSpace */0) {
                    return React.createElement(CrmErrorBoundary.make, {
                                children: React.createElement("div", undefined, React.createElement(HeaderComponent.make, {}), React.createElement(React.Suspense, {
                                          children: React.createElement(LazyWorkSpaceComponentWrapper.make, {
                                                initialTab: route._0
                                              }),
                                          fallback: React.createElement(CircularLoader$Catalyst.make, {})
                                        })),
                                fallBackComponent: (function (param) {
                                    return React.createElement(SomethingWentWrongCmp.make, {
                                                reload_cb: (function (param) {
                                                    window.location.reload();
                                                    
                                                  })
                                              });
                                  })
                              });
                  } else {
                    return React.createElement(CrmErrorBoundary.make, {
                                children: React.createElement(React.Suspense, {
                                      children: React.createElement(LazyOrderMapWrapperComponent.make, {
                                            order_id: route._0
                                          }),
                                      fallback: React.createElement(CircularLoader$Catalyst.make, {})
                                    }),
                                fallBackComponent: (function (param) {
                                    return React.createElement(SomethingWentWrongCmp.make, {
                                                reload_cb: (function (param) {
                                                    window.location.reload();
                                                    
                                                  })
                                              });
                                  })
                              });
                  }
                })
            });
}

var App = {
  findSomeWithDefault: findSomeWithDefault,
  getInitialRoute: getInitialRoute,
  make: App$App
};

export {
  App ,
  
}
/* react Not a pure module */
